// extracted by mini-css-extract-plugin
export default {"productGallery":"SN-z","inQuickShop":"TN-z"};